/**
 * Generate a deterministic, friendly fallback display name from a pubkey,
 * used when a user has no kind 0 metadata name.
 */
const ADJECTIVES = [
  'Faithful', 'Humble', 'Gracious', 'Devout', 'Wise', 'Patient', 'Kind',
  'Steadfast', 'Gentle', 'Bright', 'Noble', 'Quiet', 'Bold', 'Merciful',
];

const NOUNS = [
  'Pilgrim', 'Scribe', 'Disciple', 'Seeker', 'Reader', 'Traveler', 'Witness',
  'Sojourner', 'Student', 'Herald', 'Servant', 'Shepherd', 'Watcher', 'Friend',
];

export function genUserName(pubkey: string): string {
  let hash = 0;
  for (let i = 0; i < pubkey.length; i++) {
    hash = (hash * 31 + pubkey.charCodeAt(i)) >>> 0;
  }
  const adj = ADJECTIVES[hash % ADJECTIVES.length];
  const noun = NOUNS[(hash >> 8) % NOUNS.length];
  return `${adj} ${noun}`;
}
